import { ApiParams, ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import { PlaylistModel, PlaylistReqModel } from '@modules/digital-signage/model/playlists.model';
import { DigitalSignageScreensModel } from '@modules/digital-signage/model/screens.model';

export const getPlaylists = async (
  params?: ApiParams
): Promise<ApiResponse<PlaylistModel>> => {
  const response = await axiosInstance.get('/signage/playlists/getter', {
    params
  });
  return response.data;
};

export const createPlaylist = async (body: PlaylistReqModel): Promise<PlaylistModel> => {
  const response = await axiosInstance.post('/signage/playlists', body);
  return response.data;
};

export const editPlaylist = async (id: string, body: PlaylistReqModel): Promise<PlaylistModel> => {
  const response = await axiosInstance.put(`/signage/playlists/${id}`, body);
  return response.data;
};

export const deletePlaylist = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/signage/playlists/${id}`);
};

export const deletePlaylistsMany = async (ids: string[]): Promise<void> => {
  await axiosInstance.delete('/signage/playlists/many', { data: { ids } });
};

export const getPlaylistsList = async (): Promise<PlaylistModel[]> => {
  const response = await axiosInstance.get('/signage/playlists');
  return response.data;
};

export const getScreensList = async (): Promise<DigitalSignageScreensModel[]> => {
  const response = await axiosInstance.get('/signage/screens');
  return response.data;
};
